<template>
    <v-container fluid class="px-0 pt-5 px-md-1">
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64">

            </v-progress-circular>
        </v-overlay>
        <!--<Sidebar />-->
        <div v-if="!previst">
            <v-row>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card class=" mx-1 pt-3 primary">
                        <center>
                            <v-list-item-title class="text-h5 mb-1 primary" color="white" style="color:white">
                                Turnados
                            </v-list-item-title>
                        </center>

                    </v-card>
                </v-col>
                <v-col lg=6 sm=6 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="end">

                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="90">
                                        <v-img src="https://www.ausa.com.mx/img/colisionN.png"></v-img>
                                    </v-list-item-avatar>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <br />
                                <v-row justify="center">
                                    <br />
                                    <span style="font-size: 25px;" :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'">
                                        Colisiones
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 15px;">
                                        {{dataTurnadoColision.NameMesActualColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 40px; color:#3364FF">
                                        {{dataTurnadoColision.MesActualColision}}
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoColision.MesAnteriorColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px; ">
                                        {{dataTurnadoColision.NameMesAnteriorColision}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoColision.DosMesAnteriorColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoColision.NameDosMesActualColision}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoColision.MesAnteriorAñoAnteriorColision}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoColision.NameMesAnteriorAñoAnteriorColision}}
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>
                        <v-row><br /><br /></v-row>
                        <v-row>

                            <v-col cols="12" sm="12">
                                <center>
                                    <v-row justify="center">
                                        <span style="font-size: 32px; color:#3364FF">
                                            {{dataTurnadoColision.VigenciaActualColision}}
                                        </span>
                                    </v-row>
                                    <v-row justify="center">
                                        <span style="font-size: 15px;  ">
                                            {{dataTurnadoColision.NameVigenciaActualColision}}
                                        </span>
                                    </v-row>
                                </center>
                            </v-col>
                        </v-row>
                        <br />

                    </v-card>

                </v-col>

                <v-col lg=6 sm=6 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="end">

                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="90">
                                        <v-img src="https://www.ausa.com.mx/img/roboN.png"></v-img>
                                    </v-list-item-avatar>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <br />
                                <v-row justify="center">
                                    <br />
                                    <span style="font-size: 25px;" :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'">
                                        Robos
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameMesActualRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 40px; color:#3364FF">
                                        {{dataTurnadoRobo.MesActualRobo}}
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoRobo.MesAnteriorRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameMesAnteriorRobo}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoRobo.DosMesAnteriorRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameDosMesActualRobo}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="center">
                                    <span style="font-size: 32px; color:#3364FF">
                                        {{dataTurnadoRobo.MesAnteriorAñoAnteriorRobo}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span style="font-size: 15px;  ">
                                        {{dataTurnadoRobo.NameMesAnteriorAñoAnteriorRobo}}
                                    </span>
                                </v-row>

                            </v-col>
                        </v-row>
                        <v-row><br /><br /></v-row>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <center>
                                    <v-row justify="center">
                                        <span style="font-size: 32px; color:#3364FF">
                                            {{dataTurnadoRobo.VigenciaActualRobo}}
                                        </span>
                                    </v-row>
                                    <v-row justify="center">
                                        <span style="font-size: 15px;  ">
                                            {{dataTurnadoRobo.NameVigenciaActualRobo}}
                                        </span>
                                    </v-row>
                                </center>
                            </v-col>
                        </v-row>


                        <br />

                    </v-card>

                </v-col>
            </v-row>

            <!--2° diapositiva  pendientes-->

            <v-row>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card class="mx-1 pt-3 primary">
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Pendientes
                            </v-list-item-title>

                            <div v-if="loadingExcelPendientes == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcel(1)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>
                    </v-card>
                </v-col>
                <v-col lg=6 sm=6 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="end">
                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="90">
                                        <v-img src="https://www.ausa.com.mx/img/colisionN.png"></v-img>
                                    </v-list-item-avatar>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <br />
                                <v-row justify="center">
                                    <br />
                                    <span style="font-size: 25px;" :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'">
                                        Colisiones
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3" sm="3">
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayores != 0" class="wrexlink" @click="prevista(1)" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayores}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayores == 0" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMayores}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMayores != 0" class="wrexlink" @click="prevista(1)" style="font-size: 15px;  ">
                                        Mayores
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMayores == 0" style="font-size: 15px;  ">
                                        Mayores
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="2" sm="2">
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenores != 0" class="wrexlink" @click="prevista(2)" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenores}}
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenores == 0" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesColision.ColisionesMenores}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataPendientesColision.ColisionesMenores != 0" class="wrexlink" @click="prevista(2)" style="font-size: 15px;  ">
                                        Menores
                                    </span>
                                    <span v-if="dataPendientesColision.ColisionesMenores == 0" style="font-size: 15px;  ">
                                        Menores
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                            </v-col>
                        </v-row>

                        <br />

                    </v-card>

                </v-col>

                <v-col lg=6 sm=6 md=6 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="4" sm="4">
                                <v-row justify="end">
                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="90">
                                        <v-img src="https://www.ausa.com.mx/img/roboN.png"></v-img>
                                    </v-list-item-avatar>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <br />
                                <v-row justify="center">
                                    <br />
                                    <span style="font-size: 25px;" :class="'defaultConst--text font-weight-bold mr-2 mr-lg-1 mr-lg-2 my-1 px-2'">
                                        Robos
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3" sm="3">
                            </v-col>
                            <v-col cols="3" sm="3">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosDenuncias != 0 && permiso" class="wrexlink" @click="prevista(5)" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesRobo.RobosDenuncias}}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenuncias == 0 || !permiso" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesRobo.RobosDenuncias}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosDenuncias != 0 && permiso" class="wrexlink" @click="prevista(5)" style="font-size: 15px;  ">
                                        Solo Denuncias
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosDenuncias == 0 || !permiso" style="font-size: 15px;  ">
                                        Solo Denuncias
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="1" sm="1">
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosRecuperados != 0" class="wrexlink" @click="prevista(3)" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesRobo.RobosRecuperados}}
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosRecuperados == 0" style="font-size: 32px; color:#3364FF">
                                        {{dataPendientesRobo.RobosRecuperados}}
                                    </span>
                                </v-row>
                                <v-row justify="center">
                                    <span v-if="dataPendientesRobo.RobosRecuperados != 0" class="wrexlink" @click="prevista(3)" style="font-size: 15px;  ">
                                        Recuperados
                                    </span>
                                    <span v-if="dataPendientesRobo.RobosRecuperados == 0" style="font-size: 15px;  ">
                                        Recuperados
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="3" sm="3">
                            </v-col>
                        </v-row>

                        <br />

                    </v-card>

                </v-col>
            </v-row>

            <v-row>
                <v-col lg=12 sm=12 md=12 cols=12>

                    <v-card class="mx-1 pt-3 primary">
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Vehículos Detenidos
                            </v-list-item-title>

                            <div v-if="loadingExcelVhDet == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcel(2)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>
                    </v-card>
                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="6" sm="6">
                                <v-row justify="end">
                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="100">
                                        <v-img height="85"
                                               src="https://www.ausa.com.mx/img/carroN.png"></v-img>
                                    </v-list-item-avatar>
                                </v-row>

                            </v-col>
                            <v-col cols="2" sm="2">
                                <br />
                                <v-row justify="start">
                                    <span v-if="dataVhDetenidos.VhDetenidos != 0 && permiso" class="wrexlink" @click="prevista(4)" style="font-size: 42px; color:#3364FF">
                                        {{dataVhDetenidos.VhDetenidos}}
                                    </span>
                                    <span v-if="dataVhDetenidos.VhDetenidos == 0 || !permiso" style="font-size: 42px; color:#3364FF">
                                        {{dataVhDetenidos.VhDetenidos}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataVhDetenidos.VhDetenidos != 0 && permiso" class="wrexlink" @click="prevista(4)" style="font-size: 22px;">
                                        Vehículos Detenidos
                                    </span>
                                    <span v-if="dataVhDetenidos.VhDetenidos == 0 || !permiso" style="font-size: 22px;">
                                        Vehículos Detenidos
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>

                        <br />

                    </v-card>

                </v-col>

            </v-row>
            <v-row>
                <v-col lg=12 sm=12 md=12 cols=12>

                    <v-card class="mx-1 pt-3 primary">
                        <div class="d-flex justify-space-between align-center px-4">
                            <v-list-item-title class="text-h5 mb-1 white--text" style="text-align: center;">
                                Representación Legal Vehicular
                            </v-list-item-title>

                            <div v-if="loadingExcelRLV == false">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-on="on" v-bind="attrs"
                                               class="btnAbo" icon fab @click="DescargarExcel(3)">
                                            <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                                mdi-file-excel-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>
                            </div>

                            <v-progress-circular v-else
                                                 color="white"
                                                 indeterminate
                                                 size="24"></v-progress-circular>
                        </div>
                    </v-card>

                </v-col>
                <v-col lg=12 sm=12 md=12 cols=12>
                    <v-card style="border-left: 0.25rem solid #4e73df !important;">
                        <br />
                        <v-row>
                            <v-col cols="6" sm="6">
                                <v-row justify="end">
                                    <v-list-item-avatar tile
                                                        width="90"
                                                        height="100">
                                        <v-img height="85"
                                               src="https://www.ausa.com.mx/img/icRLV.png"></v-img>
                                    </v-list-item-avatar>
                                </v-row>

                            </v-col>
                            <v-col cols="2" sm="2">
                                <br />
                                <v-row justify="start">
                                    <span v-if="dataRLV.Total != 0 && permiso" class="wrexlink" @click="prevista(6)" style="font-size: 42px; color:#3364FF">
                                        {{dataRLV.Total}}
                                    </span>
                                    <span v-if="dataRLV.Total == 0 || !permiso" style="font-size: 42px; color:#3364FF">
                                        {{dataRLV.Total}}
                                    </span>
                                </v-row>
                            </v-col>
                            <v-col cols="4" sm="4">
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-row justify="center">
                                    <v-icon color="yellow">
                                        mdi-circle-medium
                                    </v-icon>
                                    <span v-if="dataRLV.Total != 0 && permiso" class="wrexlink" @click="prevista(6)" style="font-size: 22px;">
                                        Total de reportes
                                    </span>
                                    <span v-if="dataRLV.Total == 0 || !permiso" style="font-size: 22px;">
                                        Total de reportes
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>
                        <br />

                    </v-card>

                </v-col>

            </v-row>
        </div>

        <div v-if="previst">
            <ProcesosViews :tipo="tipo"
                           :dataPendientesColision="dataPendientesColision"
                           :dataPendientesRobo="dataPendientesRobo"
                           :dataVhDetenidos="dataVhDetenidos"
                           :dataRLV="dataRLV"
                           :filtro="filtro"
                           @regresardash="regresardash"></ProcesosViews>
        </div>



    </v-container>
</template>



<script>
    import moment from 'moment';
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import ProcesosViews from '@/components/pages/main/Dashboard/ProcesosViews.vue';
    import Inicio from '@/services/main/main.service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import Archivos from '@/services/Archivos/Archivos.service.js';
    import Dashboard from '@/services/Dashboard/Dashboard.service.js';

    export default {
        components: {
            ProcesosViews,
            //Sidebar
        },
        props: [
            'dataTurnadoColision',
            'dataTurnadoRobo',
            'dataPendientesColision',
            'dataPendientesRobo',
            'dataVhDetenidos',
            'dataRLV',
            'filtro'
        ],
        data() {
            return {
                overlay: false,
                loadingExcelPendientes: false,
                loadingExcelVhDet: false,
                loadingExcelRLV: false,
                procesos: [],
                proceso: 0,
                nombre: '',
                permiso: false,
                cont: 1,
                previst: false,
                busqueda: {
                    todo: false,
                    proceso: '',
                    aseguradora: '',
                    flotilla: '',
                    estado: '',
                    gerencia: '',
                    supervisoria: '',
                    abogado: '',
                    relevancia: '',
                    perfil: '',
                    seccion: ''
                },
            }
        },

        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE']),
            ...mapState('Operacion', ['busquedaTablero', 'key', 'verificarBusqueda']),
            computedDate() {
                return this.date ? moment(this.date).format('Do MMM YYYY, dddd') : ''
            },
        },
        methods: {
            ...mapMutations('Operacion', ['asignarBusqueda', 'cambiarKey', 'verificandoBusqueda']),
            async DescargarExcel(tipo) {
                this.overlay= true;
                this.busqueda = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");
                if (tipo == 1) {//pendientes
                    this.loadingExcelPendientes = true;
                    var formData3 = new FormData();

                    formData3.append("data", JSON.stringify([this.busqueda]));
                    formData3.append("tipo", 1);
                    const response = await Dashboard.ObtenerPendientesColisionesRobosExcel(this, formData3);
                    
                    let today = moment().format('yyyy-MM-DD');
                    let nombreArchivo = 'Pendientes-' + today.toString();
                    await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                    this.overlay = false;
                    this.loadingExcelPendientes = false;

                    var formData = new FormData();
                    formData.append("lasitio", 'Prusia+');
                    formData.append("lomodulo", 'Dashboard');
                    formData.append("laaccion", "Descargar Archivo excel");
                    formData.append("lacaracteristicas", 'Pendientes');
                    formData.append("lanombre", nombreArchivo + ".xlsx");
                    formData.append("ladestinatario", " ");
                    Archivos.AlmacenarVisitas(formData).then(data => {
                    });
                }
                else if (tipo == 2) {//veh detenidos
                    this.loadingExcelVhDet = true;
                    var formData3 = new FormData();

                    formData3.append("data", JSON.stringify([this.busqueda]));
                    formData3.append("tipo", 1);
                    const response = await Dashboard.ObtenerVhDetenidosExcel(this, formData3);
                    
                    let today = moment().format('yyyy-MM-DD');
                    let nombreArchivo = 'VehDetenidos-' + today.toString();
                    await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                    this.overlay = false;
                    this.loadingExcelVhDet = false;

                    var formData = new FormData();
                    formData.append("lasitio", 'Prusia+');
                    formData.append("lomodulo", 'Dashboard');
                    formData.append("laaccion", "Descargar Archivo excel");
                    formData.append("lacaracteristicas", 'Vehículos Detenidos');
                    formData.append("lanombre", nombreArchivo + ".xlsx");
                    formData.append("ladestinatario", " ");
                    Archivos.AlmacenarVisitas(formData).then(data => {
                    });
                }
                else if (tipo == 3) {//rlv
                    this.loadingExcelRLV = true;
                    var formData3 = new FormData();

                    formData3.append("data", JSON.stringify([this.busqueda]));
                    formData3.append("tipo", 1);
                    const response = await Dashboard.ObtenerRLVExcel(this, formData3);
                    
                    let today = moment().format('yyyy-MM-DD');
                    let nombreArchivo = 'RLV-' + today.toString();
                    await MetodosGenerales.exportToExcel(response, nombreArchivo, true, false);
                    this.overlay = false;
                    this.loadingExcelRLV = false;

                    var formData = new FormData();
                    formData.append("lasitio", 'Prusia+');
                    formData.append("lomodulo", 'Dashboard');
                    formData.append("laaccion", "Descargar Archivo excel");
                    formData.append("lacaracteristicas", 'RepresentacionLegalVH');
                    formData.append("lanombre", nombreArchivo + ".xlsx");
                    formData.append("ladestinatario", " ");
                    Archivos.AlmacenarVisitas(formData).then(data => {
                    });
                }
                

            },
            prevista(tipo) {
                
                this.previst = true;
                this.tipo = tipo;
            },
            regresardash() {
                this.previst = false;
            },

            async generarTableroVHDetenidos(idproceso, PTabNombre, seccion) {
                let datos;
                if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
                    datos = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");


                    if (this.cont == 1) {
                        this.cont++;
                        datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                        datos.aiclave = '1,24';
                        datos.seccion = seccion;
                        datos.relevancia = null;
                        datos.vehDetTipo = null;
                        await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                        this.verificandoBusqueda(false);
                        this.asignarBusqueda(datos);
                        this.cambiarKey({ tipo: 'T', key: Math.random() });
                        this.$router.push({ name: `tableroDB` });
                    }
                }
                else
                    location.reload();
            },
            async generarTableroRobosDenuncias(idproceso, PTabNombre, seccion) {
                let datos;
                
                if (window.sessionStorage.getItem("BusquedaFiltrox") != null) {
                    datos = await MetodosGenerales.obtenerSessionReporte("BusquedaFiltrox");

                    if (this.cont == 1) {
                        this.cont++;


                        datos.proceso = { PTabClave: idproceso, PTabNombre: PTabNombre };
                        datos.aiclave = '24';
                        datos.seccion = seccion;
                        datos.relevancia = null;
                        datos.vehDetTipo = null;
                        this.busqueda =await MetodosGenerales.guardarEnSesionInfoReporte(datos, "BusquedaFiltrox");
                        this.verificandoBusqueda(false);
                        this.asignarBusqueda(datos);
                        this.cambiarKey({ tipo: 'T', key: Math.random() });

                        this.$router.push({ name: `tableroDB` });
                    }
                }
                else
                    location.reload();
            },
        },
        mounted() {
            this.permiso = true;
        }
    }
</script>

<style>
    span.wrexlink {
        cursor: pointer;
    }
</style>